import BaseLoader from './BaseLoader';
export default BaseLoader;